import { render, staticRenderFns } from "./DocumentPage3.vue?vue&type=template&id=001f07d0&scoped=true&"
import script from "./DocumentPage3.vue?vue&type=script&lang=js&"
export * from "./DocumentPage3.vue?vue&type=script&lang=js&"
import style0 from "./DocumentPage3.vue?vue&type=style&index=0&id=001f07d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001f07d0",
  null
  
)

export default component.exports